import { Button } from '@/shared/components'
import { useState } from 'react'
import { authService } from '../auth-service'
import { AuthError } from '../components/auth-error'
import SouthernWaterLogo from '@/assets/Southern_Water_Logo.svg'
import SiteWorksLogo from '@/assets/SiteWorks_Logo.svg'
import HeroImage from '@/assets/Seven_Sisters_Hero.jpg'
import SouthernWaterWatermark from '@/assets/Southern_Water_Watermark.svg'
import PasskeyIcon from '@/assets/icons/passkey.svg'
import { useLocation } from 'react-router-dom'

export const LoginPage = () => {
  const [error, setError] = useState<Error | null>(null)
  const location = useLocation()
  const from = (location.state as { from?: Location })?.from

  const handleSignIn = async () => {
    setError(null)
    try {
      const destination = from ? `${from.pathname}${from.search}${from.hash}` : undefined
      await authService.loginRedirect(undefined, destination)
    } catch (e) {
      setError(e instanceof Error ? e : new Error('Sign-in failed'))
    }
  }

  return (
    <main className="flex min-h-dvh">
      <section className="flex w-[38%] min-w-[488px] shrink-0 flex-col bg-background py-16 pl-6 pr-6">
        <header className="flex min-h-[45px] w-full items-end justify-between self-stretch border-b border-muted-foreground/20 pb-8">
          <img
            src={SouthernWaterLogo}
            className="h-[42px]"
            title="Southern Water logo"
          />
          <img
            src={SiteWorksLogo}
            className="h-[32px]"
            title="Site Works logo"
          />
        </header>

        <div className="mt-54 flex flex-col items-center self-center gap-8">
          <h1 className="text-2xl font-bold text-foreground">
            Log in to the SiteWorks Portal
          </h1>

          {error ? (
            <AuthError error={error} onRetry={() => void authService.loginRedirect()} />
          ) :
            <Button
              type="button"
              className="w-full"
              icon={PasskeyIcon}
              onClick={() => void handleSignIn()}
            >
              Login with SSO
            </Button>
          }
        </div>
      </section>

      <section className="relative min-h-dvh flex-1 overflow-hidden">
        <img src={HeroImage} alt="" className="size-full object-cover" />
        <img
          src={SouthernWaterWatermark}
          alt=""
          aria-hidden
          className="pointer-events-none absolute -right-10 bottom-0 mb-5 w-[80%]"
        />
      </section>
    </main>
  )
}
